








import { defineComponent } from '@vue/composition-api';
import { useAdCampaign } from '@/bundles/Ad/composables/useAdCampaign';
import AdCampaign from '@/bundles/Ad/models/AdCampaign';
import { CreateAdCampaignDto } from '@/bundles/Ad/dto';

import AdCampaignFormBase from '@/bundles/Ad/components/AdCampaignFormBase.vue';

export default defineComponent({
  name: 'AdCampaignCreateForm',

  components: {
    AdCampaignFormBase,
  },

  emits: ['form:close', 'item:refresh'],

  setup (_, { emit }) {
    const { defaultCampaignData, createCampaign, createLoading } = useAdCampaign();
    const adCampaign = new AdCampaign(defaultCampaignData);
    async function submitEventHandler (payload: CreateAdCampaignDto) {
      await createCampaign(payload);
      emit('form:close');
      emit('item:refresh');
    }

    return {
      adCampaign,
      createLoading,
      submitEventHandler,
    };
  },
});
